import { render, staticRenderFns } from "./AddressesWidget.vue?vue&type=template&id=5164535a&scoped=true"
import script from "./AddressesWidget.vue?vue&type=script&lang=js"
export * from "./AddressesWidget.vue?vue&type=script&lang=js"
import style0 from "./AddressesWidget.vue?vue&type=style&index=0&id=5164535a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5164535a",
  null
  
)

/* custom blocks */
import block0 from "./AddressesWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports